(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- toast + cart count ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  function addToCart(id, qty) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  /* ---------- mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var list = document.getElementById(navToggle.getAttribute('aria-controls'));
      var open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      list.classList.toggle('is-open', !open);
    });
  }

  /* ---------- quick add (upsell buttons) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    btn.disabled = true;
    addToCart(btn.getAttribute('data-quick-add'), 1)
      .then(function () {
        if (btn.hasAttribute('data-reload')) { window.location.reload(); return; }
        btn.textContent = 'Added ✓';
        toast('Added to cart');
        return refreshCount();
      })
      .catch(function (err) { btn.disabled = false; toast(err.message); });
  });

  /* ---------- product page ---------- */
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  var dataEl = section.querySelector('[data-variants]');
  var data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], strings: {} };
  var form = section.querySelector('[data-product-form]');
  var idInput = section.querySelector('[data-variant-id]');
  var addBtn = section.querySelector('[data-add]');
  var priceWrap = section.querySelector('[data-price-wrap]');
  var saveEl = section.querySelector('[data-save]');
  var stockEl = section.querySelector('[data-stock]');
  var mainImg = section.querySelector('[data-main-image]');

  function setMainImage(src) {
    if (!mainImg || !src) return;
    mainImg.removeAttribute('srcset');
    mainImg.src = src;
  }

  section.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      section.querySelectorAll('[data-thumb]').forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
      setMainImage(t.getAttribute('data-thumb'));
    });
  });

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  function render(v) {
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? data.strings.add : data.strings.soldOut;

    var html = '<div class="price price--lg" data-price><span class="price__now">' + esc(v.price) + '</span>';
    if (v.compare) html += '<span class="price__was">' + esc(v.compare) + '</span><span class="price__off">−' + v.pct + '%</span>';
    priceWrap.innerHTML = html + '</div>';

    if (saveEl) {
      saveEl.hidden = !v.save;
      var strong = saveEl.querySelector('strong');
      if (strong && v.save) strong.textContent = v.save;
    }

    if (stockEl) {
      if (!v.available) stockEl.innerHTML = '';
      else if (v.low) stockEl.innerHTML = '<span class="stock__low">' + esc(data.strings.onlyLeft.replace('__N__', v.low)) + '</span>';
      else stockEl.innerHTML = '<span class="stock__ok">' + esc(data.strings.inStock) + '</span>';
    }

    setMainImage(v.image);

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  section.addEventListener('change', function (e) {
    if (!e.target.matches('[data-option]')) return;
    var chosen = [];
    section.querySelectorAll('.opt').forEach(function (fs) {
      var c = fs.querySelector('input:checked');
      chosen.push(c ? c.value : null);
    });
    var match = data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    render(match);
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      addToCart(idInput.value, 1)
        .then(function () {
          addBtn.textContent = 'Added ✓';
          toast('Added to cart — ');
          toastEl.innerHTML = 'Added to cart · <a href="' + root + 'cart">View cart →</a>';
          return refreshCount();
        })
        .catch(function (err) { toast(err.message); })
        .finally(function () {
          setTimeout(function () { addBtn.disabled = false; addBtn.textContent = label; }, 1400);
        });
    });
  }
})();
